var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, Link } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
var colors = {
    primary: {
        color: function (theme) { return theme.palette.primary[700]; },
        backgroundColor: function (theme) { return theme.palette.primary[200]; },
        border: function (theme) { return "1px solid ".concat(theme.palette.primary.main); },
    },
    info: {
        color: 'text.primary',
        backgroundColor: 'background.default',
        border: function (theme) { return "1px solid ".concat(theme.palette.text.secondary); },
    },
};
export function ExternalHelperResource(_a) {
    var text = _a.text, url = _a.url, color = _a.color;
    return (_jsxs(Link, __assign({ sx: __assign({ display: 'flex', alignItems: 'center', gap: '0.25rem', width: 'fit-content', height: 'fit-content', textDecoration: 'none', borderRadius: 1, py: 0.25, px: 1.5, '&:hover': {
                textDecoration: 'none',
            } }, colors[color]), href: url, target: "_blank" }, { children: [_jsx(Typography, __assign({ variant: "body2", lineHeight: "0" }, { children: text })), _jsx(OpenInNew, { fontSize: "small" })] })));
}
